import * as React from 'react';
import {
    CreateButton,
    DateField,
    FilterButton,
    List,
    SearchInput,
    TopToolbar,
    TextField,
    DatagridConfigurable,
    SelectColumnsButton,
    WithListContext,
    DatagridLoading,
    Pagination,
    FunctionField,
} from 'react-admin';
import { useMediaQuery, Theme, Chip } from '@mui/material';

const statusChoices = {
    0: { label: 'Aktiivinen', color: 'success' as const },
    1: { label: 'Poistettu', color: 'error' as const },
    2: { label: 'Luonnos', color: 'warning' as const },
};

const userFilters = [<SearchInput source="q" alwaysOn />];

const ListActions = () => {
    const isSmall = useMediaQuery<Theme>(theme => theme.breakpoints.down('md'));
    return (
        <TopToolbar>
            {isSmall ? <FilterButton /> : null}
            <SelectColumnsButton />
            <CreateButton />
        </TopToolbar>
    );
};

const MaterialstorageList = ({ resource }: { resource?: string }) => {
    const isSmall = useMediaQuery<Theme>(theme => theme.breakpoints.down('md'));
    const sortable = [
        'name',
        'path',
        'status',
        'created',
        'modified',
        'creator_name',
        'modifier_name',
    ];

    return (
        <List
            resource={resource}
            {...(resource
                ? {
                      storeKey: 'materialstorageListEmbedded',
                      disableSyncWithLocation: true,
                  }
                : {})}
            filters={isSmall ? userFilters : userFilters}
            sort={{ field: 'name', order: 'ASC' }}
            perPage={50}
            pagination={
                <Pagination rowsPerPageOptions={[10, 25, 50, 100, 200]} />
            }
            actions={<ListActions />}
        >
            <WithListContext
                render={({ isLoading, isFetching }) =>
                    isLoading || isFetching ? (
                        <DatagridLoading nbChildren={6} nbFakeLines={8} />
                    ) : (
                        <DatagridConfigurable omit={['guid']} rowClick="edit">
                            <TextField
                                source="guid"
                                key="guid"
                                sortable={sortable.includes('guid')}
                            />
                            <TextField
                                source="name"
                                key="name"
                                sortable={sortable.includes('name')}
                            />
                            <TextField
                                source="path"
                                key="path"
                                sortable={sortable.includes('path')}
                            />
                            <FunctionField
                                source="status"
                                key="status"
                                sortable={sortable.includes('status')}
                                render={record => {
                                    const s = statusChoices[record?.status] || {
                                        label: record?.status,
                                        color: 'default' as const,
                                    };
                                    return (
                                        <Chip
                                            label={s.label}
                                            color={s.color}
                                            size="small"
                                        />
                                    );
                                }}
                            />
                            <DateField
                                source="created"
                                key="created"
                                showTime={false}
                                locales="fi-FI"
                                sortable={sortable.includes('created')}
                            />
                            <TextField
                                source="creator_name"
                                key="creator_name"
                                sortable={sortable.includes('creator_name')}
                            />
                            <DateField
                                source="modified"
                                key="modified"
                                showTime={false}
                                locales="fi-FI"
                                sortable={sortable.includes('modified')}
                            />
                            <TextField
                                source="modifier_name"
                                key="modifier_name"
                                sortable={sortable.includes('modifier_name')}
                            />
                        </DatagridConfigurable>
                    )
                }
            />
        </List>
    );
};

export default MaterialstorageList;
